module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Employee",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addEmployee.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', [_vm._v("Full Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('InputText', {
    attrs: {
      "id": "firstName"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('InputText', {
    attrs: {
      "id": "middleName"
    },
    model: {
      value: (_vm.middleName),
      callback: function($$v) {
        _vm.middleName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "middleName"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "middleName"
    }
  }, [_vm._v("Middle Name")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('InputText', {
    attrs: {
      "id": "lastName"
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lastName"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "employeeId"
    }
  }, [_vm._v("Employee Id")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "employeeId"
    },
    model: {
      value: (_vm.employeeNumber),
      callback: function($$v) {
        _vm.employeeNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "employeeNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "credentials"
    }
  }, [_vm._v("Create Login Details")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "p-ml-5",
    attrs: {
      "binary": true,
      "id": "credentials"
    },
    model: {
      value: (_vm.createLogin),
      callback: function($$v) {
        _vm.createLogin = $$v
      },
      expression: "createLogin"
    }
  })], 1)]), _vm._v(" "), (_vm.createLogin) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('InputText', {
    attrs: {
      "id": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("User Name")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('Password', {
    attrs: {
      "id": "newPassword"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newPassword"
    }
  }, [_vm._v("Password")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('span', {
    staticClass: "p-float-label"
  }, [_c('InputText', {
    attrs: {
      "id": "confirmPassword"
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirmPassword"
    }
  }, [_vm._v("Confirm Password")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "userRole"
    }
  }, [_vm._v("User Role")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.roleLists,
      "optionLabel": "name",
      "placeholder": "Select Role",
      "id": "userRole"
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.statusList,
      "optionLabel": "name",
      "placeholder": "Select Status",
      "id": "status"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d7c3d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/createEmployee.vue
// module id = 2132
// module chunks = 0